//Aquí voy a implementar mi dashboard
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { autoLogout } from '../app/authSlice.js'

import Sidebar from './components-layout/Sidebar'
import WarningModal from './components-modals/WarningModal.js'
import Footer from './components-layout/Footer.js'

const Layout = ({ children, userObj, activeTab }) => {
    
    const dispatch = useDispatch()

    //Converti nombre a proper case
    userObj.LoginId = userObj.LoginId.split(' ').map(x => {
        return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()
    }).join(' ')

    //Prueba con useIdleTimer
    const timeout = 40000 * 60 * 0.5 //Tiempo de inactividad que dispara isIdle a true. (15 segundos)
    const [remaining, setRemaining] = useState(timeout)
    const [isIdle, setIsIdle] = useState(false)
    const handleOnIdle = () => setIsIdle(true)

    const rememberUser = useSelector(state => state.auth.rememberUser)

    const { getRemainingTime } =
        useIdleTimer({
            timeout,
            onIdle: handleOnIdle
        })

    useEffect(() => {
        setRemaining(getRemainingTime())
        setInterval(() => { setRemaining(getRemainingTime()) }, 1000)
    }, [])

    if (isIdle && !rememberUser) {
        dispatch(autoLogout()) //crear otro reducer que dispare un modal en el login diciendo que se cerro sesión por inactividad --!!!!!!
    }

    const remainingSecs = Math.floor(remaining / 1000)
    //Fin de prueba con IdleTimer

    return (
        <>
            <WarningModal
                open={remainingSecs <= 60 && !rememberUser ? true : false}
                image={
                    <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-5 icon icon-tabler icon-tabler-alert-octagon" width="60" height="60" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#e89545" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                }
                title='Aviso'
                subtitle={<span>La sesión se cerrará en <span className='text-red-600 font-semibold'>{remainingSecs} segundos</span> por inactividad</span>}
                opacity='bg-opacity-50'
            />
            <Sidebar user={userObj.LoginId} activeTab={activeTab}>
                <div className='h-full w-full'>
                    {children}
                </div>
                <Footer />
            </Sidebar>
        </>
    )

}

export default Layout